import { DysonSphere } from "@/components/ui/DysonSphere";
import { Icon } from "./LandingIcons";

interface FooterLink {
  l: string;
  h: string;
}

const FOOTER_LINKS: Record<string, FooterLink[]> = {
  Product: [
    { l: "Platform", h: "#platform" },
    { l: "Marketplace", h: "#marketplace" },
    { l: "Voice agents", h: "#" },
    { l: "Memory", h: "#" },
    { l: "Changelog", h: "#" },
  ],
  Developers: [
    { l: "SDK docs", h: "#" },
    { l: "API reference", h: "#" },
    { l: "Self-host guide", h: "#" },
    { l: "MCP servers", h: "#" },
    { l: "Status", h: "#" },
  ],
  Company: [
    { l: "Contact", h: "mailto:omanandswami2005@gmail.com" },
    {
      l: "GitHub",
      h: "https://github.com/omanandswami2005/omni-the-real-jarvis",
    },
  ],
  Legal: [
    { l: "Privacy", h: "/privacy" },
    { l: "Terms", h: "/terms" },
  ],
};

export function LandingFooter() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="nav__logo" style={{ marginBottom: 6 }}>
              <DysonSphere size={22} variant="mini" />
              <span>OMNIFORCE</span>
            </div>
            <p>
              Makers of Omni — the voice-first AI brain across every device.
              Open source. Self-hostable. Built for humans who don't want to
              think about it.
            </p>
          </div>
          {Object.entries(FOOTER_LINKS).map(([cat, links]) => (
            <div className="footer__col" key={cat}>
              <h4>{cat}</h4>
              <ul>
                {links.map((l) => (
                  <li key={l.l}>
                    <a href={l.h}>{l.l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer__bottom">
          <span>© {new Date().getFullYear()} Omniforce · Makers of Omni</span>
          <div className="footer__socials">
            <a
              href="https://github.com/omanandswami2005/omni-the-real-jarvis"
              aria-label="GitHub"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name="github" size={15} />
            </a>
            <a
              href="mailto:omanandswami2005@gmail.com"
              aria-label="Email"
            >
              <Icon name="x" size={15} />
            </a>
          </div>
          <span>omanandswami2005@gmail.com</span>
        </div>
      </div>
    </footer>
  );
}
